import * as S from "./Loading.style.js";

const Loading = () => {
  return (
    <S.LoadingLayout>
      <S.LoadingText>로딩 중입니다</S.LoadingText>
    </S.LoadingLayout>
  );
};

export default Loading;
